import React from 'react'
import {
  IssueContainer,
  InnerIssueContainer,
  MainContent,
  IssueTitle,
  SidebarP,
  Sidebar,
  SidebarHeader,
  SidebarSubheader,
  CloseButton
} from '.'

interface Props {
  handleClose: () => void
}

export default function HealthcareCard({ handleClose }: Props) {
  return (
    <IssueContainer>
      <InnerIssueContainer>
        <MainContent>
          <IssueTitle>Medicare for All</IssueTitle>
          <SidebarP>
            In the richest country on earth, no person should suffer because they cannot afford necessary medical treatment, hospital
            visits, or prescription medication. Nearly 700,000 Tennesseans are living that reality while politicians dismantle our state
            healthcare system. Justin will continue his years-long fight to preserve and expand Tennesseans’ right to healthcare by
            protecting the Affordable Care Act, fighting for reproductive rights, and supporting Medicare for All. It is time to remove the
            profit motive from healthcare and build a system that centers people, addresses outrageous costs, and guarantees quality care to
            every person living in the United States. Until that day comes, he will protect the Affordable Care Act and advocate for the
            state to expand Medicaid coverage.
          </SidebarP>
          <SidebarP>
            We cannot stand for a system that leaves private insurers in the driver’s seat while many, even those with employer insurance,
            are forced to ration their care. Justin will join 118 members of Congress in sponsoring a single-payer program and end our
            nation’s crisis of preventable suffering and medical debt that destroys lives and families every day. With Medicare for All we
            will increase coverage, expand primary care in underserved communities, and reduce out-of-pocket expenses.
          </SidebarP>
        </MainContent>
        <Sidebar>
          {/* <SidebarHeader>JUSTIN SUPPORTS</SidebarHeader>
          <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-bill/1384">
            HR 1384 - Medicare for All Act
          </SidebarSubheader>
          <SidebarP>Joining 118 co-sponsors, including TN representative Steve Cohen (TN-09).</SidebarP>
          <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-bill/275">
            HR 275 - Medicare Prescription Drug Price Negotiation Act
          </SidebarSubheader>
          <SidebarP>Joining 37 co-sponsors, including rep. Steve Cohen (TN-09).</SidebarP>
          <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-bill/465">Drug Price Relief Act</SidebarSubheader>
          <SidebarP>Joining 22 co-sponsors.</SidebarP>
          <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-bill/447">
            HR 447 - Affordable and Safe Drug Importation Act
          </SidebarSubheader>
          <SidebarP>Joining 26 co-sponsors, including rep. Steve Cohen (TN-09).</SidebarP> */}
          <SidebarHeader>RESOURCES</SidebarHeader>
          <SidebarSubheader href="https://www.census.gov/library/publications/2019/demo/p60-267.html">
            Health Insurance Coverage in the US: 2018 (US Census Bureau, Table 6)
          </SidebarSubheader>
          <SidebarSubheader href="https://www.commonwealthfund.org/biennial-explorer-interactive">
            Commonwealth Fund Health Insurance Survey
          </SidebarSubheader>
          <SidebarSubheader href="https://www.businessinsider.com/bernie-sanders-medicare-for-all-plan-cost-save-money-2018-7">
            Five Reasons Why Medicare for All Works Better than Private Health Care (video)
          </SidebarSubheader>
          <SidebarSubheader href="https://www.peri.umass.edu/images/Medicare_For_All_release_Nov18.pdf">
            Medicare for All Would Save Money
          </SidebarSubheader>
        </Sidebar>
      </InnerIssueContainer>
      <CloseButton onClick={handleClose}>CLOSE</CloseButton>
    </IssueContainer>
  )
}
